import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SuccessPlanCard,
  useSpContext,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import moment from "moment-timezone";

type EpsmPartnerAssessmentSectionProps = {
  spState: SuccessPlanState;
};

const EpsmPartnerAssessmentSection = ({ spState }: EpsmPartnerAssessmentSectionProps) => {
  const { riskItems } = useSpContext();
  const { spData } = spState;
  const { epsmRisk, epsmRiskNote } = spData;
  const histories = spData.histories || [];

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === epsmRisk);
  const filteredHistories = histories.filter(
    (history: any) => history.fieldName === "epsmRiskNote"
  );
  const noteHistories = filteredHistories.slice(1);
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard titleSlot="EPSM Partner Assessment">
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={epsmRiskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
    </SuccessPlanCard>
  );
};

export default EpsmPartnerAssessmentSection;
